import {
  createRef,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import {
  IOrderDetailMaster,
  OrderDetailMasterListProps,
} from "./IOrderDetailMaster";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import OrderDetailMasterForm from "./OrderDetailMasterForm";

const OrderDetailMasterList: FunctionComponent<OrderDetailMasterListProps> = (
  props
) => {
  const [open, setOpen] = useState<boolean>(false);
  const [isEdit, setEdit] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<IOrderDetailMaster>({
    active: true,
  });

  const { orderDetail } = props;
  console.log(">>>>>.......", orderDetail);

  const { data: createOrderDetail } = useAppSelector(
    (state) => state.CreateOrderDetailMaster
  );

  const { data: editOrderDetail } = useAppSelector(
    (state) => state.EditOrderDetailMaster
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };

  useEffect(() => {
    if (
      Object.keys(editOrderDetail ?? {}).length ||
      Object.keys(createOrderDetail ?? {}).length
    ) {
      handleClose();
    }
  }, [editOrderDetail, createOrderDetail]);
  return (
    <Fragment>
      {!open ? (
        <div className="scroll_content_container" style={{ height: "100%" }}>
          <div className="grid_container">
            <div className="detail_item">
              <label className="f4">Retailer Name</label>
              <p>{orderDetail?.retail?.name}</p>
            </div>
            <div className="detail_item">
              <label className="f4">Order Number</label>
              <p>{orderDetail?.order_no}</p>
            </div>
            <div className="detail_item">
              <label className="f4">Distributor Name</label>
              <p>{orderDetail?.distributor?.name}</p>
            </div>
          </div>

          <div className="common_table_container2">
            <TableContainer
              component={Paper}
              style={{ maxHeight: "450px", overflowY: "auto" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ minWidth: "40px" }}>S.No</TableCell>
                    <TableCell style={{ minWidth: "100px" }}>Item</TableCell>
                    <TableCell style={{ minWidth: "150px" }}>
                      Style_Color
                    </TableCell>
                    <TableCell style={{ minWidth: "300px" }}>
                      Quantity Of Size
                    </TableCell>
                    <TableCell style={{ minWidth: "130px" }}>
                      Sum Of Qty
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderDetail?.order_detail?.map((row, index) => (
                    <TableRow key={row?.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row?.product}</TableCell>
                      <TableCell
                        style={{
                          textOverflow: "ellipsis !important",
                          overflow: "hidden !important",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row?.style + "_" + row?.color}
                      </TableCell>
                      <TableCell>
                        <div className="quantity_divider">
                          {row?.qty_sizes?.map((data) => (
                            <span key={data.id}>
                              <b>{data.size ? data.size : 0}</b>&nbsp;:&nbsp;{data.qty ? data.qty : 0}
                            </span>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell>
                        {row?.qty_sizes?.reduce(
                          (sum, data) => sum + Number(data.qty),
                          0
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <label className="f4 float-end mt-4">
              Toatal Quantity = <span>{orderDetail?.totalqty}</span>
            </label>
          </div>
        </div>
      ) : (
        <div className="d-flex">
          <OrderDetailMasterForm
            open={open}
            initialValues={initialValues}
            handleClose={handleClose}
            setInitialValues={setInitialValues}
          />
        </div>
      )}

      {/* <>
        <Dialog
          PaperProps={{
            style: { borderRadius: 0 },
          }}
          open={open}
          onClose={handleClose}
          maxWidth={"md"}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="d-flex">
            <DialogTitle id="alert-dialog-title" className="font-weight-700">
              {"Add OrderDetails"}{" "}
            </DialogTitle>
            <div className="ms-auto p-3">
              <CancelIcon
                onClick={() => {
                  handleClose();
                }}
                sx={{
                  color: "#D1D1D1",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <DialogContent>
            <OrderDetailMasterForm
              initialValues={initialValues}
              handleClose={handleClose}
              setInitialValues={setInitialValues}
            />
          </DialogContent>
        </Dialog>

        <CompletePopup
          data={{ data: createOrderDetail }}
          responsePopup={Object.keys(createOrderDetail ?? {}).length}
          setCompletePopup={(e: any) => {
            dispatch(clearCreateItemDetailMaster());
            setResponsePopup(false);
          }}
        />
        <CompletePopup
          data={{ data: editOrderDetail }}
          responsePopup={Object.keys(editOrderDetail ?? {}).length}
          setCompletePopup={(e: any) => {
            dispatch(clearEditItemDetailMaster());
            setResponseEdit(false);
          }}
        />
      </> */}
    </Fragment>
  );
};

export default OrderDetailMasterList;
